import audiophileImg from "../assets/images/audiophile.png";
import chatAppImg from "../assets/images/ChatAppwebsite.png";
import devfinderImg from "../assets/images/devfinder.png";
import easybankImg from "../assets/images/Easybanklandingpage.png";
import sneakersImg from "../assets/images/ecommerceproductpage.png";
import freshmartImg from "../assets/images/freshmart.png";
import restcountriesImg from "../assets/images/restcountries.png";
import sunnysideImg from "../assets/images/Sunnysideagencylandingpage.png";
import anthonyportfolioImg from "../assets/images/anthonywaweru.png";

export const data = [
  {
    id: "audiophile",
    lead: "Project Showcase",
    title: "Audiophile E-commerce",
    description:
      "A modern front-end e-commerce platform for audio enthusiasts featuring dynamic product catalog, interactive shopping cart, and seamless checkout flow. Built with React, Redux for state management, and styled-components for a responsive, mobile-first design.",
    live: "https://audiophile-ecommerce-navy.vercel.app/",
    github: "https://github.com/anthonynjeri/audiophile-ecommerce",
    image: audiophileImg,
    techStack: ["React", "Redux", "JavaScript", "Styled Components"],
  },
  {
    id: "chatapp",
    lead: "Project Showcase",
    title: "Chat App Landing Page",
    description:
      "Modern landing page design for a chat application concept. Features responsive design, smooth animations, and clean UI/UX principles implemented in Webflow.",
    live: "https://chat-app-home-page-60f3d4.webflow.io/",
    github: null, // Webflow project
    image: chatAppImg,
    techStack: ["Webflow", "CSS", "JavaScript"],
  },
  {
    id: "devfinder",
    lead: "Project Showcase",
    title: "GitHub User Finder",
    description:
      "A responsive web application that integrates with the GitHub API to search and display user profiles with detailed information including repositories, followers, and activity.",
    live: "https://scintillating-melomakarona-39ef86.netlify.app/",
    github: "https://github.com/anthonynjeri/github-user-search",
    image: devfinderImg,
    techStack: ["JavaScript", "CSS", "GitHub API", "Responsive Design"],
  },
  {
    id: "easybank",
    lead: "Project Showcase",
    title: "EasyBank Landing Page",
    description:
      "Modern banking website landing page with smooth animations, responsive design, and clean UI. Translated from Figma designs to pixel-perfect implementation.",
    live: "https://benevolent-griffin-d83450.netlify.app/",
    github: "https://github.com/anthonynjeri/easybank-landing-page",
    image: easybankImg,
    techStack: ["HTML", "SASS", "JavaScript", "Responsive Design"],
  },
  {
    id: "sneakers",
    lead: "Project Showcase",
    title: "Sneakers E-commerce Page",
    description:
      "Product page for an e-commerce sneaker store featuring image gallery, product variants, add to cart functionality, and responsive design optimized for mobile and desktop.",
    live: "https://zealous-edison-de12bb.netlify.app/",
    github: "https://github.com/anthonynjeri/ecommerce-product-page",
    image: sneakersImg,
    techStack: ["HTML", "CSS", "JavaScript", "Responsive Design"],
  },
  {
    id: "freshmart",
    lead: "Project Showcase",
    title: "Mange Grocery Store",
    description:
      "Full-featured online grocery store with product catalog, search functionality, shopping cart, and Stripe payment integration. Uses multiple APIs for product data and checkout processing.",
    live: "https://fresh-mart-omega.vercel.app/",
    github: "https://github.com/anthonynjeri/fresh-mart",
    image: freshmartImg,
    techStack: ["React", "JavaScript", "Stripe API", "REST API"],
  },
  {
    id: "restcountries",
    lead: "Project Showcase",
    title: "REST Countries Explorer",
    description:
      "Interactive web application to explore world countries with search, filter by region, and detailed country information. Features dark/light mode toggle and responsive design.",
    live: "https://rest-countries-api-three-blue.vercel.app/",
    github: "https://github.com/anthonynjeri/rest-countries-API",
    image: restcountriesImg,
    techStack: ["JavaScript", "CSS", "REST Countries API", "Local Storage"],
  },
  {
    id: "sunnyside",
    lead: "Project Showcase",
    title: "Sunnyside Agency Landing",
    description:
      "Creative agency landing page with modern design, smooth scrolling, responsive layout, and optimized performance. Features testimonials section and service showcase.",
    live: "https://clinquant-crostata-4d246f.netlify.app/",
    github: "https://github.com/anthonynjeri/sunnyside-agency",
    image: sunnysideImg,
    techStack: ["HTML", "CSS", "JavaScript", "Responsive Design"],
  },
  // {
  //   id: "anthonyportfolio",
  //   lead: "Project Showcase",
  //   title: "Personal Portfolio V2",
  //   description:
  //     "My previous portfolio website featuring custom design, smooth animations, project showcase, and contact form. Built with React and modern web technologies.",
  //   live: "https://www.anthonynjeri.com",
  //   github: "https://github.com/anthonynjeri/portfolio-v2",
  //   image: anthonyportfolioImg,
  //   techStack: ["React", "Styled Components", "Figma", "Framer Motion"],
  // },
];
